import React from "react";
import s from "./GiftUser.module.scss";
import { Button } from "antd";
import { SubmitHandler, useForm } from "react-hook-form";
import clsx from "clsx";
import Gift from "../../../../../../global components/Icons/Gift/Gift";
import useSWRMutation from "swr/mutation";
import {
  parseClientError,
  swrMutationFetcher,
} from "../../../../../../libs/api/Endpoints";
import { generateResult } from "../../../../../../global components/ResultModal/ResultModal";
type Inputs = {
  credits: number;
  reason: string;
};
type prop = {
  userId: string;
  name: string | undefined;
  handleClose: () => void;
};
function GiftUser({ name, userId, handleClose }: prop) {
  const {  isMutating } = useSWRMutation(
    "",
    swrMutationFetcher
  );
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<Inputs>();
  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    console.log(data);
    try {
    } catch (error) {
      const e = parseClientError(error);
      generateResult("error", e.message || "Something went wrong");
    }
  };
  const handleCancel = () => {
    reset();
    handleClose();
  };
  return (
    <div className={s.wrapper}>
      <div className={s.titles}>
        <Gift height={36} width={36} />
        <h3 className={s.title}>Gift {name}</h3>
        <h4 className={s.subtitle}>Send a Special Surprise</h4>
      </div>
      <form className={s.form} onSubmit={handleSubmit(onSubmit)}>
        <div className={s.inputWrapper}>
          <h5 className={s.inputLabel}>
            How many credits do you want to send?
          </h5>
          <input
            className={clsx(s.input, { [s.inputError]: errors.credits })}
            {...register("credits", {
              required: true,
              min: { value: 0, message: "Credits cannot be less than 0" },
            })}
            type="number"
            placeholder="Enter no of credits"
            min={0}
          />
          {errors.credits && (
            <p className={s.errorMessage}>{errors.credits.message}</p>
          )}
        </div>
        <div className={s.inputWrapper}>
          <h5 className={s.inputLabel}>Reason for sending it</h5>
          <input
            type="text"
            placeholder="Type reason here"
            className={clsx(s.input, { [s.inputError]: errors.reason })}
            {...register("reason")}
          />
          {errors.reason && (
            <p className={s.errorMessage}>{errors.reason.message}</p>
          )}
        </div>

        <div className={s.btnGroups}>
          <Button onClick={handleCancel} className={s.cancelBtn}>
            Cancel
          </Button>

          <Button loading={isMutating} htmlType="submit" className={s.sendBtn}>
            Send
          </Button>
        </div>
      </form>
    </div>
  );
}

export default GiftUser;
